export enum FiatCurrencySymbolEnum {
    BRL = 'R$',
    USD = '$',
    EUR = '€',
    NOT_DEFINED = ''
}
